import { Link } from 'react-router-dom';

export default function Benefits() {
  const benefits = [
    {
      icon: 'ri-speed-up-line',
      title: 'Szybkość i wydajność',
      desc: 'USFansSpreadsheet działa błyskawicznie nawet przy dużych zbiorach danych, co znacząco przyspiesza codzienną pracę z arkuszami kalkulacyjnymi.',
    },
    {
      icon: 'ri-team-line',
      title: 'Współpraca zespołowa',
      desc: 'Pracuj z zespołem w czasie rzeczywistym, udostępniaj arkusze i śledź zmiany – wszystko w jednym miejscu, bez konieczności wysyłania plików.',
    },
    {
      icon: 'ri-shield-check-line',
      title: 'Bezpieczeństwo danych',
      desc: 'Twoje dane są szyfrowane i chronione zgodnie z najwyższymi standardami bezpieczeństwa. Regularne kopie zapasowe zapewniają spokój.',
    },
    {
      icon: 'ri-puzzle-line',
      title: 'Integracje',
      desc: 'Łatwo integruj USFansSpreadsheet z popularnymi narzędziami i platformami, które już wykorzystujesz w swojej codziennej pracy.',
    },
    {
      icon: 'ri-smartphone-line',
      title: 'Dostępność mobilna',
      desc: 'Korzystaj z USFansSpreadsheet na dowolnym urządzeniu – przeglądarka, smartfon czy tablet. Twoje dane zawsze pod ręką.',
    },
    {
      icon: 'ri-bar-chart-line',
      title: 'Zaawansowana analityka',
      desc: 'Wbudowane narzędzia analityczne pomagają szybko przekształcać surowe dane w czytelne wykresy, raporty i prognozy.',
    },
  ];

  return (
    <section className="py-14 md:py-20 bg-background-100">
      <div className="max-w-[1280px] mx-auto px-4 md:px-6">
        <div className="text-center mb-10 md:mb-14">
          <span className="inline-block px-3 py-1 rounded-full bg-accent-100 text-accent-700 text-xs font-medium mb-4">
            Korzyści
          </span>
          <h2 className="font-heading text-2xl md:text-4xl font-bold text-foreground-950 mb-4">
            Dlaczego warto korzystać z USFansSpreadsheet?
          </h2>
          <p className="text-foreground-600 max-w-[600px] mx-auto leading-relaxed">
            Odkryj kluczowe zalety, które sprawiają, że USFansSpreadsheet to jedno z najlepszych 
            narzędzi do zarządzania arkuszami kalkulacyjnymi dostępnych na rynku.
          </p>
        </div>

        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-5 md:gap-6">
          {benefits.map((item) => (
            <div
              key={item.title}
              className="group p-5 md:p-6 rounded-xl bg-background-50 border border-background-200/70 hover:border-primary-200 transition-all duration-300"
            >
              <span className="w-11 h-11 flex items-center justify-center rounded-lg bg-primary-100 text-primary-600 mb-4 group-hover:bg-primary-500 group-hover:text-background-50 transition-colors duration-300">
                <i className={`${item.icon} text-lg`}></i>
              </span>
              <h3 className="font-heading text-lg font-semibold text-foreground-950 mb-2">{item.title}</h3>
              <p className="text-sm text-foreground-600 leading-relaxed">{item.desc}</p>
            </div>
          ))}
        </div>

        <div className="text-center mt-10">
          <Link
            to="/artykul/kompletny-przewodnik-usfansspreadsheet-2026"
            className="inline-flex items-center gap-2 px-6 py-3 rounded-lg text-sm font-semibold bg-primary-500 text-background-50 hover:bg-primary-600 transition-colors whitespace-nowrap cursor-pointer"
          >
            <i className="ri-book-open-line"></i>
            Poznaj wszystkie funkcje
          </Link>
        </div>
      </div>
    </section>
  );
}